import { Component, input } from '@angular/core';
import { OnyxIconComponent } from '../../icons/onyx-icon/onyx-icon.component';

@Component({
  selector: 'onyx-close-button',
  imports: [OnyxIconComponent],
  templateUrl: './onyx-close-button.component.html',
  styleUrl: './onyx-close-button.component.scss',
})
export class OnyxCloseButtonComponent {
  public readonly color = input.required<
    'green' | 'red' | 'gray' | 'yellow' | 'blue' | 'black' | 'transparent'
  >();
}
